// import { m } from 'framer-motion';
import React, { useContext, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { getBalanceTopUpOptions } from 'src/api/api';


import PricingHomeCard from './HomePricingCard';


// ----------------------------------------------------------------------

// type Props = {
//   plans: IPricingHomeProps[];
// };

export default function PricingHome() {
  const [plans, setPlans] = useState([
    { "amount": "loading", "bonus": 0 },
    { "amount": "loading", "bonus": 1 },
    { "amount": "loading", "bonus": 1 },
  ]);

  useEffect(() => {
    const getBalanceTopUp = async () => {
      const topUpOptionsResp = await getBalanceTopUpOptions();
      if (topUpOptionsResp.error) {
        return
      }
      setPlans(topUpOptionsResp.options);
    }

    getBalanceTopUp();
  }, []);

  return (
    <Container
      sx={{
        pt: { xs: 10, md: 15 },
        pb: { xs: 5, md: 10 },
      }}
    >
      <Box
        sx={{
          mb: { xs: 8, md: 10 },
          textAlign: 'center',
        }}
      >
        <Typography variant="h2">
          Top Up Plans
        </Typography>
      </Box>

      <Box
        sx={{
          gap: 4,
          display: 'grid',
          alignItems: 'center',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            md: 'repeat(4, 1fr)',
          },
        }}
      >
        {plans.map((plan, index) => (
          // <m.div key={plan.license} variants={varFade().inUp}>
          <PricingHomeCard key={index} plan={plan} optionIndex={index} />
          // </m.div>
        ))}
      </Box>
    </Container>
  );
}
